/**
 * Guía: Devoluciones de saldo a cuenta bancaria.
 *
 * El manual técnico aún no tiene capítulo para esta pantalla (llegó el
 * 2026-10-15); se cuelga del **24** (Billeteras) como `24b` y el contenido
 * sale de `WALLET_LOYALTY.md` del backend. Cuando el capítulo exista, se
 * revisa contra él.
 *
 * Lo que más importa que quede claro: el saldo sale al registrar, no al
 * transferir, y anular es solo para lo que no se transfirió.
 */

import type { TourFlow } from '../types';

const DEVOLUCIONES_PATH = '/finance-wallet-withdrawals';

export const c24bDevolucionesDeSaldo: TourFlow = {
  id: 'admin.finance-wallet-withdrawals',
  chapter: '24b',
  title: 'Devoluciones de saldo',
  summary:
    'Cómo devolverle a un cliente su saldo 121 en su cuenta bancaria, y por qué el saldo sale antes de transferir.',
  href: DEVOLUCIONES_PATH,
  requiresCountry: false,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'Para qué existe',
      body:
        'Wompi solo reversa tarjeta y Nequi. Un pedido pagado con PSE o Bancolombia que se ' +
        'cancela se reembolsa al saldo 121 del cliente. Si el cliente quiere ese dinero en ' +
        'su cuenta, se registra aquí y se transfiere desde la banca empresarial.',
      route: DEVOLUCIONES_PATH,
    },
    {
      id: 'debit-first',
      title: 'El saldo sale al registrar',
      body:
        'No al transferir: si siguiera en la billetera, el cliente podría gastarlo y recibir ' +
        'además la transferencia. Por eso registrar ya descuenta, y el cliente lo ve.',
    },
    {
      id: 'mark-paid',
      title: 'Marcar transferida',
      body:
        'Con la referencia del comprobante del banco. Al marcarla, el cliente recibe un aviso ' +
        'con el banco y los últimos cuatro dígitos de la cuenta.',
    },
    {
      id: 'cancel',
      title: 'Anular es solo para lo que no salió',
      body:
        'Anular devuelve el monto al saldo del cliente. Si ya transferiste, no se anula: ' +
        'queda como transferida. Ver la cuenta completa queda registrado en auditoría.',
    },
  ],
};
